import React from 'react';
import {withSystem, Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {extraAttrs} from '../utils';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {TText, TRecord} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const UserAccountFormCancelButton = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const buttonClasses = classes.push('w-button');

    return <input {...generateAttributes(attributes, buttonClasses)} />;
  }
);

const config = createIntegratedAtom({
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Button')),
  },
  constraints: {
    page: [{type: 'UtilityPage', is: ['usys-user-account']}],
  },
  showEmpty: false,
  displayName: 'Cancel Button',
  render: UserAccountFormCancelButton,
  fields: {
    attr: withSystem(
      {private: false},
      TRecord(
        {
          value: withSystem({label: 'Text', isFullWidth: true}, TText),
        },
        extraAttrs
      )
    ),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          textAlign: 'center',
          backgroundColor: createRgbaColor('d3d3d3'),
          color: createRgbaColor('333'),
        },
      },
    },
  },
});

export default config;
